import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.625 2.5C10.2798 2.5 10 2.77982 10 3.125C10 3.47018 10.2798 3.75 10.625 3.75L15 3.75V16.25H10.625C10.2798 16.25 10 16.5298 10 16.875C10 17.2202 10.2798 17.5 10.625 17.5H15C15.3315 17.5 15.6495 17.3683 15.8839 17.1339C16.1183 16.8995 16.25 16.5815 16.25 16.25V3.75C16.25 3.41848 16.1183 3.10054 15.8839 2.86612C15.6495 2.6317 15.3315 2.5 15 2.5H10.625ZM6.90273 6.27675C7.14684 6.0327 7.54257 6.03276 7.78661 6.27687L11.067 9.55812C11.311 9.80218 11.311 10.1978 11.067 10.4419L7.78661 13.7231C7.54257 13.9672 7.14684 13.9673 6.90273 13.7232C6.65862 13.4792 6.65857 13.0835 6.90262 12.8394L9.1164 10.625H1.875C1.52982 10.625 1.25 10.3452 1.25 10C1.25 9.65482 1.52982 9.375 1.875 9.375H9.1164L6.90262 7.16063C6.65857 6.91652 6.65862 6.5208 6.90273 6.27675Z",
  fill: "#FFFFFF"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }